import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { ApplyForOdCoDto } from "./apply-for-od-co-dto";

export class ApplyForOdCoResponseModel extends GlobalResponseObject{
    data?: ApplyForOdCoDto[];

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ApplyForOdCoDto[]){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}